import { Theme, css } from '@emotion/react';

export const title = ({ colors, spacing }: Theme) => css`
  border-bottom: 1px solid ${colors.borderDefault};
  padding-bottom: ${spacing(4)}px;
`;

export const sectionListItem = ({ spacing }: Theme) => css`
  list-style-type: none;
  margin-bottom: ${spacing(2)}px;
`;
